<template>
  <v-card
    hover
    class="queue-card"
    :raised="isActive"
    @click="show">
    <v-card-title primary-title :class="headerClasses">
      <v-row>
        <v-col md="1">
          <v-badge :value="callsNum > 0" class="head-icon">
            <span slot="badge">
              <v-tooltip bottom light>
                <template v-slot:activator="{ on }">
                  <span  v-on="on">{{ callsNum }}</span>
                </template>
                <span>{{ $t('queues.tooltip.inCalls') }}</span>
              </v-tooltip>
            </span>
            <v-icon :color="isActive ? 'white' : ''">mdi-account-multiple</v-icon>
          </v-badge>
        </v-col>
        <v-col md="8">
          <h4 :class="isActive ? 'text-truncate white--text' : 'text-truncate'">
            {{ queue.name }}
          </h4>
        </v-col>
        <v-col md="1">
          <v-badge :value="agentsOnCall > 0" color="primary darken-2" overflow>
            <span slot="badge">
              <v-tooltip bottom light>
                <template v-slot:activator="{ on }">
                  <span  v-on="on">{{ agentsOnCall }}</span>
                </template>
                <span>{{ $t('queues.tooltip.agentsOnCall') }}</span>
              </v-tooltip>
            </span>
          </v-badge>
        </v-col>
      </v-row>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <QueueCardBody :queue="queue" />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import QueueCardBody from './card_body'

export default {
  name: 'queue-card',
  props: {
    queue: {
      type: Object,
      required: true
    }
  },
  components: { QueueCardBody },
  computed: {
    ...mapGetters({
      activeQueue: 'queues/active'
    }),
    showBadge: function () {
      return (this.callsNum + this.agentsOnCall) > 0
    },
    agentsOnCall: function () {
      return this.queue.agents.reduce((n, a) => n + a.oncall, 0)
    },
    callsNum: function () {
      return this.queue.calls?.length ?? 0
    },
    isActive: function () {
      return this.queue === this.activeQueue
    },
    headerClasses: function () {
      return {
        primary: this.isActive,
        'pt-3': true,
        'pb-2': true
      }
    }
  },
  methods: {
    ...mapActions({
      showAgents: 'queues/showAgentsPane',
      setActiveQueue: 'queues/setActive'
    }),
    async show () {
      const showAgentDrawer = !this.isActive
      await this.setActiveQueue(showAgentDrawer ? this.queue : null)
      await this.showAgents(showAgentDrawer)
    }
  }
}
</script>

<style scoped>
.head-icon {margin-right: 8px}
</style>
